import { render, staticRenderFns } from "./VHome.vue?vue&type=template&id=4c1bba85&scoped=true&"
import script from "./VHome.vue?vue&type=script&lang=js&"
export * from "./VHome.vue?vue&type=script&lang=js&"
import style0 from "./VHome.vue?vue&type=style&index=0&id=4c1bba85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1bba85",
  null
  
)

export default component.exports